import React from "react";
import ButtonCore from "../ButtonCore";
import { IButtonUIInterface } from "../interface";

const SolidButton: React.FC<React.PropsWithChildren<IButtonUIInterface>> = (props) => {
  return <ButtonCore type="solid" {...props} />;
};

export default SolidButton;
